import React, { Component } from 'react'
import language from 'utils/vast-languagepack'

export default class SmartNotesPage extends Component {
  render() {
    return (
      <div>
        {language.smartNotes.smartNotesHeading}
      </div>
    )
  }
}
